/* Component Dependencies */
var logoWithHeaderTextTemplate = require('templates/logoWithHeaderText.hbs');
var logoWithHeaderTextRewardsTemplate = require('templates/logoWithHeaderText-rewards.hbs');
var logoWithHeaderTextPopUpTemplate = require('templates/logoWithHeaderText-popup.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'logoWithHeaderText',
    template: {
        'logoWithHeaderText': logoWithHeaderTextTemplate,
        'logoWithHeaderText-rewards': logoWithHeaderTextRewardsTemplate,
        'logoWithHeaderText-popup':logoWithHeaderTextPopUpTemplate
    }
});
